import { render, staticRenderFns } from "./CourseContentPage.vue?vue&type=template&id=65ae2290&scoped=true"
import script from "./CourseContentPage.vue?vue&type=script&lang=js"
export * from "./CourseContentPage.vue?vue&type=script&lang=js"
import style0 from "./CourseContentPage.vue?vue&type=style&index=0&id=65ae2290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ae2290",
  null
  
)

export default component.exports